import * as React from "react";
import { Text } from "@/components/atoms/Text";
import { cn } from "@/lib/utils";

type PriceLineItemTooltipTitleProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Heading for tooltips that supply their own body via `renderContent`. The
 * modal presentation renders the title as `DialogTitle`; the popover and its
 * mobile drawer have no header chrome of their own, so they use this instead.
 */
const PriceLineItemTooltipTitle = ({
  children,
  className,
}: PriceLineItemTooltipTitleProps) => (
  <Text
    className={cn("tw-mb-16", className)}
    element="h3"
    typeface="headline-3-m"
  >
    {children}
  </Text>
);

PriceLineItemTooltipTitle.displayName = "PriceLineItemTooltipTitle";

export { PriceLineItemTooltipTitle, type PriceLineItemTooltipTitleProps };
